import { useEffect, useRef, useState } from 'react';

const useIntersection = ({ root = null, rootMargin, threshold = 0 }) => {
  const [entry, updateEntry] = useState({});
  const [node, setNode] = useState(null);

  const observer = useRef();

  useEffect(() => {
    observer.current = new IntersectionObserver(([_entry]) => updateEntry(_entry), {
      root,
      rootMargin,
      threshold
    });
  }, []);

  useEffect(() => {
    const { current: currentObserver } = observer;
    currentObserver.disconnect();

    if (node) currentObserver.observe(node);

    return () => currentObserver.disconnect();
  }, [node]);

  return [setNode, entry];
};

export default useIntersection;
